import type { Graph, Thing, WithContext } from 'schema-dts'

// JSON-LD script contents are raw text: HTML entities would change names and
// URLs. JSON escapes keep the original data and cannot close the script tag.
export const serializeJsonLd = (item: unknown): string => JSON.stringify(item)
  .replace(/</g, '\\u003c')
  .replace(/>/g, '\\u003e')
  .replace(/&/g, '\\u0026')
  .replace(/\u2028/g, '\\u2028')
  .replace(/\u2029/g, '\\u2029')

export function JsonLd(props: { item: Graph }): JSX.Element
export function JsonLd<T extends Thing>(props: { item: WithContext<T> }): JSX.Element
export function JsonLd({ item }: { item: unknown }): JSX.Element {
  return <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: serializeJsonLd(item) }} />
}
